import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import { Notification, Typography } from '@telus-uds/components-web';

import { getPathVariables } from '../../misc';

import {
  DueMonthlyWrapper,
  DueNowWrapper,
  ButtonsWrapper,
  Button,
  Flex,
  LabelDueMonthly,
  BeforeTaxesLabel,
  PricingBlockMain,
  IntegralPart,
  FractionalPart,
  Currency
} from './css';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';

const Desktop = ({
  dueMonthly,
  dueNow,
  onSaveAndExit,
  onSubmit,
  hidePricing,
  formErrors,
  isSubmitting
}) => {
  const localizedStringsContext = useLocalizedStringsContext();
  const {
    ORDERS: { DUE_MONTHLY, DUE_NOW, BEFORE_TAXES, saveAndContinueLater },
    formButtons: { submitButtonLabel, submittingButtonLabel },
    iotOrderDetailsSection: { labelImpactedByContract }
  } = localizedStringsContext;

  const [showFooterError, setShowFooterError] = useState(false);

  const getFormattedPricing = pricing => {
    const newPricing = pricing.replace('$', '');
    const locale = getPathVariables(window.location.pathname)[0];
    return (
      <>
        <IntegralPart>
          {newPricing.split('.')[0]}
          <FractionalPart>
            <Typography variant={{ inline: true }}>
              {locale === 'fr-CA' ? ',' : '.'}
            </Typography>
            {newPricing.split('.')[1]}
          </FractionalPart>
        </IntegralPart>
        <Currency style={{ order: locale === 'fr-CA' ? '3' : '-1' }}>
          $
        </Currency>
      </>
    );
  };

  useEffect(() => {
    setShowFooterError(Object.keys(formErrors).length > 0);
  }, [formErrors]);

  return (
    <div id="footer-high">
      <>
        <DueMonthlyWrapper>
          <div>
            <LabelDueMonthly>{DUE_MONTHLY}</LabelDueMonthly>{' '}
            {hidePricing ? (
              <p>{labelImpactedByContract}</p>
            ) : (
              <>
                <PricingBlockMain>
                  {getFormattedPricing(dueMonthly)}
                </PricingBlockMain>
                <BeforeTaxesLabel>{BEFORE_TAXES}</BeforeTaxesLabel>
              </>
            )}
          </div>
        </DueMonthlyWrapper>
        <DueNowWrapper>
          <>
            <div>
              <LabelDueMonthly>{DUE_NOW}</LabelDueMonthly>
              {hidePricing ? (
                <p>{labelImpactedByContract}</p>
              ) : (
                <>
                  <PricingBlockMain>
                    {getFormattedPricing(dueNow)}
                  </PricingBlockMain>
                  <BeforeTaxesLabel>{BEFORE_TAXES}</BeforeTaxesLabel>
                </>
              )}
            </div>
          </>
        </DueNowWrapper>
        <ButtonsWrapper>
          <Flex>
            <Button>
              <button
                type="button"
                onClick={e => onSaveAndExit(e)}
                className="frg-button color-purple"
                disabled={isSubmitting}
              >
                <span>{saveAndContinueLater}</span>
              </button>
            </Button>
            <Button>
              <button
                type="button"
                onClick={e => onSubmit(e)}
                className="frg-button color-green"
                disabled={isSubmitting}
              >
                <span>{isSubmitting ? submittingButtonLabel : submitButtonLabel}</span>
              </button>
            </Button>
          </Flex>
        </ButtonsWrapper>
        {showFooterError && (
          <div style={{ display: 'inline-block' }}>
            <Notification
              variant={{validation: 'error'}}
              copy="en"
              dismissible
              onDismiss={() => setShowFooterError(false)}
            >
              <Typography>There is an error in the form</Typography>
            </Notification>
          </div>
        )}
      </>
    </div>
  );
};

Desktop.propTypes = {
  dueMonthly: PropTypes.string.isRequired,
  dueNow: PropTypes.string.isRequired,
  onSaveAndExit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  hidePricing: PropTypes.bool.isRequired,
  formErrors: PropTypes.shape({}).isRequired,
  isSubmitting: PropTypes.bool
};

export default Desktop;
